import { HttpClient } from '@angular/common/http';
import { normalizeApiBaseUrl } from 'src/app/shared/utils/api-base-url';
import { JSON_HTTP_OPTIONS } from 'src/app/shared/utils/json-http-options';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PaymentService {
  constructor(private router: Router, private http: HttpClient) { }
GetPackageDetails(): Observable<any> {
    const body = {};
    return this.http.get(`${normalizeApiBaseUrl(environment.ASquareAPIURL)}Razorpay/package-details`, JSON_HTTP_OPTIONS);
  }

  InsertPaymentDataForSubscription(data): Observable<any> {
    const body = data ;
    return this.http.post(`${normalizeApiBaseUrl(environment.ASquareAPIURL)}Razorpay/payment-data-for-subscription`, body, JSON_HTTP_OPTIONS);
  }

  UpdatePaymentStatus(data): Observable<any> {
    const body = data ;
    return this.http.put(`${normalizeApiBaseUrl(environment.ASquareAPIURL)}Razorpay/payment-status`, body, JSON_HTTP_OPTIONS);
  }
}
